import React from "react";

interface RimaLogoProps {
  size?: number;
}

export const RimaLogo = ({ size = 24 }: RimaLogoProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6173 0.158513C17.8623 0.0570186 18.1377 0.0570187 18.3827 0.158513L30.3452 5.11356C30.5903 5.21506 30.7849 5.40973 30.8864 5.65476L35.8415 17.6173C35.943 17.8623 35.943 18.1377 35.8415 18.3827L30.8864 30.3452C30.7849 30.5903 30.5903 30.7849 30.3452 30.8864L18.3827 35.8415C18.1377 35.943 17.8623 35.943 17.6173 35.8415L5.65476 30.8864C5.40973 30.7849 5.21506 30.5903 5.11356 30.3452L0.158513 18.3827C0.0570186 18.1377 0.0570187 17.8623 0.158513 17.6173L5.11356 5.65476C5.21506 5.40973 5.40973 5.21506 5.65476 5.11356L17.6173 0.158513Z"
        fill="url(#rima_logo_gradient)"
      />
      <path
        d="M17.8086 0.620117C17.9311 0.569405 18.0689 0.569405 18.1914 0.620117L30.1543 5.5752C30.2766 5.62594 30.3741 5.72337 30.4248 5.8457L35.3799 17.8086C35.4306 17.9311 35.4306 18.0689 35.3799 18.1914L30.4248 30.1543C30.3741 30.2766 30.2766 30.3741 30.1543 30.4248L18.1914 35.3799C18.0689 35.4306 17.9311 35.4306 17.8086 35.3799L5.8457 30.4248C5.72337 30.3741 5.62594 30.2766 5.5752 30.1543L0.620117 18.1914C0.569405 18.0689 0.569405 17.9311 0.620117 17.8086L5.5752 5.8457C5.62594 5.72338 5.72338 5.62594 5.8457 5.5752L17.8086 0.620117Z"
        stroke="rgba(225,180,250,0.5)"
        strokeOpacity="1"
      />
      <defs>
        <radialGradient
          id="rima_logo_gradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18 18) rotate(90) scale(17.4545)"
        >
          <stop offset="0%" stopColor="#E1B4FA" />
          <stop offset="100%" stopColor="#FFFFFF" />
        </radialGradient>
      </defs>
    </svg>
  );
};
